import {
  FaReact,
  FaJs,
  FaHtml5,
} from 'react-icons/fa';
import {
  SiRedux,
  SiMaterialdesign,
  SiAxios
} from 'react-icons/si';
import { FaChartBar } from 'react-icons/fa';
import { IoLogoCss3 } from 'react-icons/io5';
import { SiReactrouter } from 'react-icons/si';
import { RiTailwindCssFill } from 'react-icons/ri';

export const projects = [
  {
    name: 'Exos Systems',
    link: 'https://www.exos-systems.com/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'Tailwind CSS', icon: <RiTailwindCssFill /> }
    ]
  },
  {
    name: '10 Billion',
    link: 'https://10billion.org/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'Tailwind CSS', icon: <RiTailwindCssFill /> }
    ]
  },
  {
    name: 'Aubichol',
    link: 'https://www.aubichol.com/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'React', icon: <FaReact /> },
      { label: 'Redux', icon: <SiRedux /> },
      { label: 'Material-UI', icon: <SiMaterialdesign /> },
      { label: 'Axios', icon: <SiAxios /> }
    ]
  },
  {
    name: 'Khelahobe!',
    link: 'https://www.khelahobe.co/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'React', icon: <FaReact /> },
      { label: 'Redux', icon: <SiRedux /> },
      { label: 'Material-UI', icon: <SiMaterialdesign /> },
      { label: 'Axios', icon: <SiAxios /> },
      { label: 'Chart.js', icon: <FaChartBar /> },
      { label: 'React Router', icon: <SiReactrouter /> }
    ]
  },
  {
    name: 'Gaachwala',
    link: 'https://www.gaachwala.com/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'React', icon: <FaReact /> },
      { label: 'Redux', icon: <SiRedux /> },
      { label: 'Material-UI', icon: <SiMaterialdesign /> },
      { label: 'Axios', icon: <SiAxios /> },
      { label: 'React Router', icon: <SiReactrouter /> }
    ]
  },
  {
    name: 'Suit and Sarto',
    link: 'https://suitandsarto.com/',
    technologies: [
      { label: 'HTML', icon: <FaHtml5 /> },
      { label: 'CSS', icon: <IoLogoCss3 /> },
      { label: 'JavaScript', icon: <FaJs /> },
      { label: 'React', icon: <FaReact /> },
      { label: 'Redux', icon: <SiRedux /> },
      { label: 'React Router', icon: <SiReactrouter /> },
      { label: 'Material-UI', icon: <SiMaterialdesign /> }
    ]
  }
];
